import React from 'react';
import moment from 'moment';
import { gql } from '@common/hooks';
import { Col } from 'antd';
import { Card, Icon } from '@common/components';

type Props = {
  licenses: {
    id: string;
    state: string;
    number: string;
    expiresOn: string;
    friendlyLicenseType: string;
  }[];
};

export function Licenses({ licenses }: Props) {
  return (
    <Col span={24}>
      <Card title="Licenses">
        {licenses.length === 0 && <div>No license information available</div>}
        <ul className="fa-ul profile-right-card-list">
          {licenses.length > 0 &&
            licenses.map((license) => {
              return (
                <li key={license.id}>
                  <span className="fa-li">
                    <Icon icon="idCardAlt" kind="light" />
                  </span>
                  <strong>{license.state}</strong>
                  <div>
                    {license.friendlyLicenseType}
                    {license.number && ` - ${license.number}`}
                    <br />

                    {license.expiresOn && (
                      <em className="card-expiration">
                        Exp: {moment(license.expiresOn).format('MMM YYYY')}
                      </em>
                    )}
                  </div>
                </li>
              );
            })}
        </ul>
      </Card>
    </Col>
  );
}

Licenses.fragments = {
  license: gql`
    fragment LicensesLicenseFragment on License {
      id
      state
      number
      expiresOn
      friendlyLicenseType
    }
  `,
};
